var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var CheckmarkGreen = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.5637 5.1109C15.8476 5.30714 15.9187 5.69643 15.7225 5.98039L10.1813 13.9983C9.28448 15.296 7.37533 15.3207 6.44518 14.0468L4.28689 11.0907C4.08335 10.8119 4.14434 10.4209 4.42313 10.2173C4.70191 10.0138 5.09291 10.0748 5.29645 10.3536L7.45474 13.3097C7.87753 13.8888 8.74533 13.8775 9.15297 13.2877L14.6942 5.26972C14.8904 4.98576 15.2797 4.91465 15.5637 5.1109Z', fill: '#147105' }) })));
};
export { CheckmarkGreen };
//# sourceMappingURL=CheckmarkGreen.js.map